import React from "react";
import styles from "./Loading.module.css";

const Loading = () => {
  return (
    <div className={styles.loadingOverlay}>
      <div className={styles.spinner}></div>
      <img className={styles.loadingImage} src="/asets/irluxe-black.png" />
    </div>
  );
};

export default Loading;
